import Vue from "vue";
import Vuex from "vuex";
import localStorage from "@/services/localStorage.service";
import { setLocalStorage } from "@/utils/vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    currentCourse: localStorage.getObject("currentCourse"),
    currentModule: localStorage.getObject("currentModule"),
    currentLesson: localStorage.getObject("currentLesson"),
    currentForum: localStorage.getObject("currentForum"),
    currentQualification: localStorage.getObject("currentQualification"),
    senceLogin: localStorage.getItem("senceLogin")
  },
  mutations: {
    setCurrentCourse(state, payload) {
      localStorage.setObject("currentCourse", payload);
      state.currentCourse = payload;
      state.currentModule = null;
    },
    setCurrentModule: setLocalStorage("currentModule"),
    setCurrentLesson: setLocalStorage("currentLesson"),
    setCurrentForum: setLocalStorage("currentForum"),
    setCurrentQualification: setLocalStorage("currentQualification"),
    setSenceLogin: setLocalStorage("senceLogin")
  }
};



// WEBPACK FOOTER //
// ./src/store/navigation/index.js